import React from "react";
import { useSelector } from "react-redux";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
import ThumborJS from "thumborjs";

const imageUrl = process.env.NEXT_PUBLIC_IMAGE_URL;
const thumborKey = process.env.NEXT_PUBLIC_THUMBOR_KEY;
const thumborUrl = process.env.NEXT_PUBLIC_THUMBOR_URL;

import { convert } from "../utils/convert";

const changProductName = (input) => {
  let name = input;
  name = name?.split("(");
  if (name.length > 1) {
    name.pop();
    name = name.join(" (");
  } else {
    name = input;
  }
  return name;
};

const color = {
  Black: "#000000",
  Blue: "#56a0f8",
  Brown: "#c58a56",
  Gold: "#feda72",
  Green: "#6dc887",
  Grey: "#bbbbbb",
  Metallic: "#a1a1a1",
  Multicolour: "#bc69e3",
  Neutrals: "#fadbae",
  Orange: "#fec470",
  Pink: "#f17fd4",
  Purple: "#be88ed",
  Red: "#f56675",
  Silver: "#d5d5d5",
  White: "#ffffff",
  Yellow: "#fdea72",
};

const CardComponent = ({ product, t, brandData }) => {
  const router = useRouter();
  let queryParam = router?.query?.aid ? `aid=${router?.query?.aid}` : ``;
  queryParam = router?.query?.pid
    ? `${queryParam}&pid=${router?.query?.pid}`
    : queryParam;

  queryParam = router?.query?.pf
    ? `${queryParam}pf=${router?.query?.pf}`
    : queryParam;

  if (router?.query?.utm_source) {
    queryParam = queryParam
      ? `${queryParam}&utm_source=${router?.query?.utm_source}`
      : `?utm_source=${router?.query?.utm_source}`;
  }

  const { currencyData } = useSelector((state) => state?.currency);
  const { currencyAllData } = useSelector((state) => state?.currencyAll);
  // fallback กัน href ออกมาเป็น /undefined เมื่อ brandData ยังไม่โหลด หรือ brand_code ไม่มีใน map
  const brandSlug =
    brandData?.[product?.brand_code] ||
    product?.brand_name ||
    product?.brand?.name_en ||
    product?.brand?.name ||
    "";
  const url =
    brandSlug && product?.category && product?.slug
      ? `/${brandSlug}/${product?.category}/${product?.slug}${
          queryParam ? `?${queryParam}` : ``
        }`
      : "#";

  const name = changProductName(product?.name);

  const myLoader = ({ src }) => {
    if (src.split("?")?.length > 1) {
      return `${src}`;
    } else {
      const tugen = new ThumborJS(thumborUrl, thumborKey);
      const url = tugen
        .imgpath(src)
        .resize(650, 650)
        .filter("format(webp)")
        .genurl();

      return url;
    }
  };

  const Price = ({ product, currencyData }) => {
    const discount = product?.discount
      ? product?.discount[currencyData]?.total_discount
      : 0;

    let sellprice_before_discount = product?.discount
      ? product?.discount[currencyData]?.sellprice_before_discount
      : 0;

    let sellprice = product?.discount
      ? product?.discount[currencyData]?.sellprice
      : product?.currency[currencyData]?.sellprice || 0;

    return (
      <>
        {discount !== 0 && (
          <div className="price-promotion-container">
            <span className="line-through text-gray-500">
              {`${currencyAllData?.[currencyData]?.symbol || ""} ${convert(
                sellprice_before_discount,
              )}`}
            </span>
            {product?.web_promotion_product?.web_promotion
              ?.discount_percent && (
              <p className="promotion-container">
                {
                  product?.web_promotion_product?.web_promotion
                    ?.discount_percent
                }
                % Off
              </p>
            )}
          </div>
        )}
        <p
          className={
            discount === 0
              ? "mt-6 mb-0 font-normal text-base text-black"
              : "mt-0 mb-0 font-normal text-base text-red-600"
          }
        >
          {`${currencyAllData?.[currencyData]?.symbol || ""} ${convert(
            sellprice,
          )}`}
        </p>
      </>
    );
  };

  const image_path = product?.imagepath_compress?.replace(/uploads\//g, "");
  const imageProduct = product?.imagepath_compress
    ? `${imageUrl}/${image_path}`
    : product?.imagepath
      ? product?.imagepath
      : `${process.env.NEXT_PUBLIC_FRONTEND_URL}/static/images/thumbnail.jpeg`;

  const is_notify =
    product?.published_at && new Date() < new Date(product.published_at);

  return (
    <div className="px-2">
      <Link href={url} title={name}>
        <div className="bg-white rounded-lg overflow-hidden w-full my-5 hover:shadow-[0_4px_15px_rgba(0,0,0,0.2)] transition-shadow ">
          <div className="bg-gray-200 relative w-full aspect-square">
            <Image
              loader={myLoader}
              src={imageProduct}
              alt={name}
              layout="fill"
              objectFit="cover"
              className="img-custom"
              quality={75}
              formats={["image/webp"]}
            />
          </div>
          <p className="mt-2 mx-4 text-md text-gray-800 line-clamp-3 h-16 overflow-hidden">
            {name}
          </p>
          <div className="flex justify-end w-full space-x-1">
            {product?.variant?.map((v) => (
              <div
                key={`color-${v}`}
                className="w-4 h-4 rounded-full"
                style={{ backgroundColor: color[v?.name] }}
              />
            ))}
          </div>
          <div className="mt-1 mb-2 mx-4">
            {is_notify ? (
              <p className="mt-6 mb-0 font-normal text-red-500">
                Notify Me When Available
              </p>
            ) : product?.is_price_on_request ? (
              <p className="mt-6 mb-0 font-normal text-gray-500">
                ASK FOR PRICE
              </p>
            ) : (
              <Price product={product} currencyData={currencyData} />
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CardComponent;
